import { render } from "./PdfView.vue?vue&type=template&id=f777a5ec&scoped=true"
import script from "./PdfView.vue?vue&type=script&lang=js"
export * from "./PdfView.vue?vue&type=script&lang=js"

import "./PdfView.vue?vue&type=style&index=0&id=f777a5ec&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f777a5ec"]])

export default __exports__